"use client";

import { Flex } from "@chakra-ui/react";
import NextLink from "next/link";
import React from "react";

import { ColorModeButton } from "@components/ui/color-mode";
import AppInitializer from "components/core/AppInitializer";
import { BrandMarkIcon } from "vectors";

const TrackingLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <AppInitializer user={null}>
      <Flex
        flexDirection="column"
        flex={1}
        bg="sidebar.background"
        height="100dvh"
        pb={2}
      >
        <Flex
          px={{ base: 4, md: 6 }}
          py={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <NextLink href="/">
            <BrandMarkIcon color="fg" height="25px" width="auto" />
          </NextLink>
          <ColorModeButton _hover={{ backgroundColor: "sidebar.hover" }} />
        </Flex>
        <Flex
          flexDirection="column"
          flex={1}
          gap={2}
          bg="surface.background"
          p={2}
          mx={2}
          overflowY="auto"
          borderRadius="lg"
        >
          {children}
        </Flex>
      </Flex>
    </AppInitializer>
  );
};

export default TrackingLayout;
